import { usePatientQuery } from "hooks/queries/usePatientQuery";
import { useVisitQuery } from "hooks/queries/useVisitQuery";

const ProdTestingPatientGroup = "fcacd5b9-631e-47d4-9aa7-e953fbf9a0ba";

export function useShowNekoLens({
  patientId,
  visitId,
}: {
  patientId: string;
  visitId: string;
}): boolean {
  const { data: patientData } = usePatientQuery({ patientId });
  const { data: visit } = useVisitQuery({ patientId, visitId });

  const groupIds = patientData?.groupIds ?? [];

  if (groupIds.includes(ProdTestingPatientGroup)) {
    return true;
  }

  const countryCode = visit?.site.address.countryCode?.toUpperCase();

  const nekoLensAvailableCountryCodes = ["SE", "GB"];
  if (
    countryCode != null &&
    nekoLensAvailableCountryCodes.includes(countryCode)
  ) {
    return true;
  }

  return false;
}
